import apiClient from './apiClient';
import RegisterChangeDataStore from '../../datastores/RegisterChangeDataStore';
import { registerChangeModalityStudies } from './schemas/changeModalityStudies';

class RegisterChangeDataStoreGraphQL implements RegisterChangeDataStore {
  client = apiClient();

  async register(
    procedureId: number,
    newModality: string,
    newModalityName: string,
    newPeriod: string,
    newCampus: string,
    plan: string,
    career: string,
    period: string,
    shift: string,
    shiftDesc: string
  ) {
    try {
      const response = await this.client.mutate({
        mutation: registerChangeModalityStudies,
        variables: {
          procedureId,
          newModality,
          newModalityName,
          newPeriod,
          newCampus,
          plan,
          career,
          period,
          shift,
          shiftDesc
        }
      });
      const { data } = response;
      return data?.registerChangeModalityOfStudies;
    } catch (error) {
      throw new Error('error register in change modality studies');
    }
  }
}

export default RegisterChangeDataStoreGraphQL;
